import React from 'react';
import { Box } from '@mui/material';
import { useLabourGroupsPanelStore } from '../stores/labourGroupsPanelStore';
import { LabourItemGroupDetails } from '../api/labourItemGroupsApi';
import GroupCreateForm from './GroupCreateForm';
import GroupEditForm from './GroupEditForm';

interface GroupLifecyclePanelProps {
  group: LabourItemGroupDetails | null;
}

const GroupLifecyclePanel: React.FC<GroupLifecyclePanelProps> = ({ group }) => {
  const mode = useLabourGroupsPanelStore(state => state.mode);

  return (
    <Box sx={{ p: 3 }} data-testid="group-lifecycle-content">
      {mode === 'create' && <GroupCreateForm />}
      {mode === 'edit' && group && <GroupEditForm group={group} />}
    </Box>
  );
};

export default GroupLifecyclePanel;
